export * from './WelcomeNamingPage';
